export const environment = {
  production: true,
  amountRegex: '',
  apiUrl: 'https://yw2znstrm5g3dpuxop3b7htqyy.appsync-api.us-east-1.amazonaws.com/graphql',
  apiKey: 'da2-qh6fqooyozepdlzdtxarxyek6u',
  ipiApi: 'https://ipapi.co/json/?key=jyazDurFj1ZWY50M4XnGzr8T9puSDKSiMqrxHwHptug8OAUvvW',
  serviceDesk: 'ServiceDesk@rollsoft.com',
  idleInterval: 120,
};
